export default __webpack_public_path__ + "static/media/Q4_0.910873e7.jpg";